export default {
  welcome: 'A micro very macro site',
  welcomeSubtitle: 'Create your microsite and a catalog to boost your business...',
  start: 'Start',
  unknown: 'Unknown',
  progressTitleStep1: 'Let\'s set up your links',
  progressTitleStep2: 'Now let\'s configure your catalog',
  progressTitleStep3: 'Preview',
  addSocialNetwork: 'Add a social network',
  whatNameDoYouWantToGiveIt: 'What name do you want to give it?',
  youCanCustomizeTheGreetingAsYouLike: 'You can customize the greeting as you like',
  addAShortDescriptionOfYourSite: 'Add a short description of your site',
  pasteTheLinkOfTheProfileFbHere: 'Paste your facebook profile here',
  chooseTheBackgroundOfYourSite: 'Choose the background of your site',
  whatIsThePriceRangeOfYourProducts: 'What is the price range of your products?',
  linkYourSocialNetworks: 'Link your social networks',
  since: 'Since',
  until: 'Until',
  whatPaymentMethodsDoYouAccept: 'What payment methods do you accept?',
  yourAddress: 'Your address',
  website: 'Website',
  addYourWhatsApp: 'Add your WhatsApp',
  pasteTheLinkOfTheProfileHere: 'Paste the link of the profile here',
  profilePicture: 'Profile picture',
  search: 'search',
  activity: 'Activity',
  flags: 'Flags',
  foods: 'Foods',
  frequently: 'Frequently',
  objects: 'Objects',
  nature: 'Nature',
  peoples: 'Peoples',
  symbols: 'Symbols',
  places: 'Places',
  whereDoYouWantToHaveYourCatalog: 'Where do you want to have your catalog?',
  microsite: 'microsite',
  whatsApp: 'WhatsApp',
  configureYourCatalog: 'Configure your catalog',
  addUpTo5ProductPhotos: 'Add up to 5 product photos',
  categoryName: 'Category name',
  productName: 'Product name',
  productCost: 'Product cost',
  productColors: 'product colors',
  addAColor: 'Add a color',
  addAShortDescriptionOfTheProduct: 'Add a short description of the product.',
  theseAreTheProductsYouHaveAdded: 'These are the products you have added',
  bulkLoad: 'Bulk Load',
  basicInformationOfYourProfile: 'Basic information of your profile',
  profilePhoto: 'Profile photo',
  pressEnterToSaveCategory: 'Press enter to save new category',
  successUploadingPicture: 'Success upload photo',
  successRemovePhotoFromProductGallery: 'Removed product photo',
  successProductAdd: 'Product added',
  successProductEdit: 'Product edited',
  apply: 'Apply',
  genericError: 'Ocurrió un error, intente más tarde',
  successCreateCatalog: 'Successfully created catalog',
  errorCreateCatalog: 'An error occurred, please try again later',
  successCreateMicrosite: 'Microsite successfully created',
  errorCreateMicrosite: 'An error occurred, please try again later',
  successEditCatalog: 'Successfully edit catalog',
  errorEditCatalog: 'An error occurred, please try again later',
  successEditMicrosite: 'Microsite successfully edit',
  errorEditMicrosite: 'An error occurred, please try again later',
  editProducts: 'Edit products',
  addOtherProduct: 'Add Other Product',
  addProduct: 'Add Product',
  youreAboutToDeleteTheSelectedProduct: 'You´re about to delete the selected product',
  productDeleted: 'Deleted product',
  publish: 'Publish',
  remove: 'Remove',
  edit: 'Edit',
  last: 'Before',
  now: 'After',
  noProuctsYet: 'no products yet',
  continue: 'Continue',
  viewSite: 'View site',
  urlSite: 'Site URL',
  urlSiteHint: 'sss',
  atLeastOneProductPhotoIsRequired: 'At least one product photo is required',
  atLeastOneCategoryIsRequired: 'At least one category is required',
  thisFieldIsRequired: 'This field is required',
  priceMustBeGreaterThanZero: 'Price must be greater than zero',
  wysiwygMaximumCharacters: 'Maximum of 140 characters',
  urlNotValid: 'URL is not valid',
  notAvailable: 'Not available',
  comingSoon: 'coming soon',
  addDescriptionYourProduct: 'Add your product description',
  letsTalk: 'let\'s talk',
  catalogue: 'Catalogue',
  copiedUrl: 'Copied URL',
  maxCharacteres: 'Maximum 24 characters',
  maxWords: 'Maximum 3 words',
  minCharacteres: 'Min 6 characters',
  personalizeIcons: 'Customize your icons',
  uploadOrSeachOnGallery: 'You can upload your own icons or select from our gallery',
  examine: 'Examine',
  iconProportions: '200x200px, png or svg format, 5kb max',
  seeAllIcons: 'See all icons',
  principalButton: 'Main button',
  secondaryButton: 'Secondary button',
  enterButtonText: 'Enter button text',
  addButton: 'Add button',
  thereMustBeAtLeastOnePrincipalButton: 'Oops! There must be at least 1 Main button'
}
